// extracted by mini-css-extract-plugin
export default {"resetButton":"T_r3yK2","root":"JGRMwvg"};